import { ApiClientProps } from "hooks/useApi";

export interface MenuGroupProps {
  menuGroupId: string;
  name: string;
  tableStatus: number;
  lastUpdate: string;
}

export interface LocationDetailsProps {
  checkMatchEnabled: boolean;
  enabled: boolean;
  id: number;
  lastUpdate: string | null | undefined;
  locationId: string;
  logWebhook: boolean;
  name: string | null;
  partnerKey: string | null;
  partnerVenueId: string;
  posType: string | null;
  skipSend: boolean;
  apiType: string | null | undefined;
  tableStatusEnabled: boolean;
  tableStatusMap:
    | {
        [menuGroupId: string]: MenuGroupProps;
      }
    | null
    | undefined;
}

interface GetLocationDetailsProps {
  id?: string | number;
  partnerId?: string;
  posType?: string | null;
  apiClient: ApiClientProps;
}

async function getLocationDetails({
  id,
  partnerId,
  posType,
  apiClient,
}: GetLocationDetailsProps): Promise<LocationDetailsProps | null> {
  if (!id || !posType) {
    return null;
  }

  try {
    const response = await apiClient.get({
      path: `/middleware-admin/partners/${partnerId}/pos/${posType}/locations/${id}`,
      noRetry: true,
    });

    return response.resource;
  } catch (error) {
    throw new Error(
      "Network request error trying to fetch the location details"
    );
  }
}

export default getLocationDetails;
